import React from "react";
import { Link } from "react-router-dom";
import Iframe from "react-iframe";

function Contactbanner() {
  return (
    <>
      <div className="contact-map">
        <Iframe
          title="bookGMapIframe"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.8935318264093!2d-73.98161152259544!3d40.7643663713859!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259550a748577%3A0xca22ff3a89d99fe5!2sKin%20ramen!5e0!3m2!1sen!2sth!4v1706629957568!5m2!1sen!2sth"
          width="100%"
          height="500"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></Iframe>
      </div>

      <section className="contact-page">
        <div className="location-center">
          <div className="auto-container">
            <div className="cinfo-box">
              <div className="row clearfix">
                <div className="contactinfo-block col-lg-4 col-md-4 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="300ms"
                  >
                    <h4>Lunch Time</h4>
                    <div className="text">
                      {" "}
                      Monday to Sunday <br />{" "}
                      <div className="more-link">
                        <Link to="#">12.00 pm - 03.00pm</Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="contactinfo-block col-lg-4 col-md-4 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="600ms"
                  >
                    <h4>Dinner Time</h4>
                    <div className="text">
                      Monday to Sunday
                      <br />
                      <div className="more-link">
                        <Link to="#">04.30 pm - 10.00 pm</Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="contactinfo-block col-lg-4 col-md-4 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="300ms"
                  >
                    <h4>Contact Info</h4>
                    <div className="text">
                      kinramennyc@gmail.com
                      <br />
                    </div>
                    <div className="more-link">
                      <Link to="https://www.instagram.com/kinramennyc">
                        Instagram
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contactbanner;
